import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import profileApi from "../services/api/profileAPI";
import { imageURL } from "../services/api/config";
import { useAuth } from "../contexts/authContext";
import NotificationBell from "./notification/notificationBell";
import CustomModal from "./Model/CustomerModel";
import ChatBox from "./chat/chat";

const Header = () => {
    const [customerProfile, setCustomerProfile] = useState('');
    const [visible, setVisible] = useState(false);

    const { logout } = useAuth();

    useEffect(() => {
        profileApi.Profile().then((response) => {
            if (response.status) {
                setCustomerProfile(response.resultData);
            }
        })
    }, [])

    const openModal = () => {
        setVisible(true);
      };

    const handleModelCancelButton = () => {
        setVisible(false);
      };

    const handleLogout = () => {
        logout();
    }

    return (
        <header className="header">
            <nav className="main-header navbar navbar-expand navbar-white navbar-light">
                <ul className="navbar-nav">

                    <li className="nav-item">
                        <a className="nav-link" data-widget="pushmenu" href="#" role="button"><i className="fas fa-bars"></i></a>
                    </li>

                    <li className="nav-item d-sm-inline block">
                        <a className="nav-link d-flex" href="#" role="button">
                            <span className="card-title">{customerProfile?.businessName}</span>
                        </a>
                    </li>
                </ul>

                <ul className="navbar-nav ml-auto">
                    <li className="nav-item d-flex align-items-center">
                        <NotificationBell />
                    </li>
                    <li className="nav-item d-flex align-items-center">
                        <ChatBox />
                    </li>
                    <li className="nav-item dropdown">
                        <a className="nav-link dropdown-toggle" data-toggle="dropdown" href="#" aria-expanded="false">

                            <img src={customerProfile?.profile ? `${imageURL}${customerProfile.profile}?t=${new Date().getTime()}` : "/default-profile.png"} alt="user" className="img-fluid img-round me-3" /><span className="drop-title d-none d-lg-inline-block">{customerProfile.name1} {customerProfile.name2}</span>

                        </a>
                        <div className="dropdown-menu dropdown-menu-lg dropdown-menu-right" style={{ left: "inherit", right: 0 }}>

                            <Link to="/profile" className="dropdown-item">Profile</Link>
                            <a onClick={() => openModal()} className="dropdown-item pointer">Logout</a>
                        </div>

                    </li>

                </ul>
            </nav>
            <CustomModal
                visible={visible}
                title="Log Out Confirmation"
                message="Are you sure you want to log out?"
                onCancel={handleModelCancelButton}
                onConfirm={handleLogout}
            />
        </header>
    );
};

export default Header;